export const convertDateToFormat = (source, format = '') => {
    let date;
    if (typeof source === 'string') {
        date = new Date(source);
    } else {
        date = new Date(source * 1000);
    }

    let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    let year = date.getFullYear();
    let month = months[date.getMonth()];
    let day = date.getDate();
    let hour = leading_zeros(date.getHours());
    let minute = leading_zeros(date.getMinutes());
    let second = leading_zeros(date.getSeconds());

    function leading_zeros(dt)
    { 
        return (dt < 10 ? '0' : '') + dt;
    }

    switch (format) {
        case 'M j, Y, H:i':
            return `${month} ${day}, ${year}, ${hour}:${minute}`;
        case 'M j, Y, H:i:s':
            return `${month} ${day}, ${year}, ${hour}:${minute}:${second}`;
        default:
            return `${month} ${day}, ${year}`;
    }
};

export const stripLength = (content, maxLength) => {
    if (content.length >= maxLength) {
        return content.substr(0, maxLength) + '...';
    }

    return content.substr(0, maxLength);
};

export const getCookie = (cname) => {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};

/**
 * Trigger Global Error Msg Modal
 */
export const triggerErrorDialog = (modalSize ="lg", message = "", btnOKText = "OK", btnCancelText="", title="", redirectUrl="") => {
    document.dispatchEvent(new CustomEvent('showSehsehErrMsg', {detail: {modalSize, title, message, btnOKText, btnCancelText, redirectUrl}}));
};

/**
 * Simulates an API request
 */
export const mockApiRequest = (value) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(value);
        }, 5000);
    });
};

/**
 * input textarea focus event
 */
 export const inputFocus = (e) => {
    e.target.closest('.form-control').classList.add('isTyping');
};

/**                                     
 * input textarea blur event
 */
 export const inputBlur = (e) => {
    e.target.closest('.form-control').classList.remove('isTyping');
}                                                                                                                                                                                                                                                                                           